module.exports = __webpack_public_path__ + "static/scale-model-of-sand-key-park-in-clearwater-florida-32cc1dd65cc4e0628dd7f054bad46d07.png";